import { render, staticRenderFns } from "./CustomerContractServicesForm.vue?vue&type=template&id=08204cb1"
import script from "./CustomerContractServicesForm.vue?vue&type=script&lang=js"
export * from "./CustomerContractServicesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports